import React, { useState, useEffect } from 'react';
 
import useTable from '../useTable'
import axios from 'axios';

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';


/* import { ToastsGeneral } from '../toasts'; */
import {
    cmes,
    formatMoneda
} from '../../util/varios';
import AgregarValorPetro from './modalAgegarValorPetro';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' },

    { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }

]

function ValorPetro() {
    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'))

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [idUsuarioH, setIdUsuarioH] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [tipo, setTipo] = useState()
    const [operacion, setOperacion] = useState(0);
    const [usuarioH, setUsuarioH] = useState();
    const [persona, setPersona] = useState();
    const [organizacion, setOrganizacion] = useState();
    const [configCome, setConfigCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(JSON.parse(localStorage.getItem('anioactu')));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [records, setRecords] = useState([]);
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [values, setValues] = useState()
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    /*   const accusertim = JSON.parse(localStorage.getItem('accusertim')); */

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        const formattedDate = moment.utc(x.fecha).format('DD-MM-YYYY h:mm A');
                        const formattedCurrency = formatMoneda(x.valor.replace(',', '').replace('.', ','), ',', '.', 2);

                        const searchValue = target.value.toLowerCase();

                        if (
                            formattedDate.includes(searchValue) ||
                            formattedCurrency.includes(searchValue)
                        ) {
                            return x;
                        }
                    });
                }
            }
        });
    };

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);
        seleccionarValor();
    }, []);

    const seleccionarValor = () => {
        setActivate(true);

        let endpoint = `${op.conexion}/api/configuracion/valorcambio`;

        console.log(endpoint)

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                console.log(response.data)
                setRecords(response.data)
                setActivate(false);

            }

            setActivate(false);

        }).catch((error) => {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        })
    };





    const gestionarUnidad = (item, op) => (e) => {
        console.log(item)
        e.preventDefault()
        setOperacion(op)
        if (op !== 1) {
            setValues(item)
            setMensajesino({ mostrar: true, titulo: 'Notificación', texto: 'Esta Seguro de eliminar Este Registro?', icono: 'informacion' })



        } else {
            setMostrar(true)

        }


    }

    const procesarRegistro = () => {

        let endpoint = `${op.conexion}/api/configuracion/actualizarvalorcambio`;

        let body = {
            operacion: 3,
            fechasistem: fechasistema,
            fecha: moment.utc(values.fecha).format('DD-MM-YYYY h:mm A'),
            valor: values.valor.replace(",", ".")
        }

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {



                setActivate(false);



                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Operacion Realizada.', icono: 'exito' });
                seleccionarValor();

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }



    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro()


    };

    return (
        <div className="h-100 w-100 p-0 m-0">

            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

            <div className="container">
                <div className="content">
                    <div className="card col-md-8 mx-auto px-3 py-2">
                        <div className="col-md-12 row m-0 py-1">

                         
                            <div className="col-md-11">

                            </div>
                            <div className="col-md-1 ">
                                <button onClick={gestionarUnidad('', 1)} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                            </div>

                        </div>
                        <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer >
                                <TblHead />

                                <tbody>
                                    {

                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                            <tr key={index} style={{ padding: "0" }}>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "200px" }}>{moment.utc(item.fecha).format('DD-MM-YYYY h:mm A')}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{formatMoneda(item.valor.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: '200px' }}>
                                                    {/*      <button onClick={gestionarUnidad(item, 4)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                                                    <button onClick={gestionarUnidad(item, 2)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                                */}     <button onClick={gestionarUnidad(item, 3)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </TblContainer>
                            <TblPagination />

                        </div>
                    </div>
                </div>
            </div>

            <AgregarValorPetro
                show={mostrar}
                onHideCancela={() => { setMostrar(false), setValues('') }}
                operacion={operacion}
                unidad={values}
                renderizar={seleccionarValor}
            />

            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
        </div >

    );

}

export default ValorPetro;